// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"1315b092","433":"e80b954c"}[chunkId] + ".chunk.js";
};